import React from 'react';
import { Link } from 'react-router-dom';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Cookie Policy</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-sm text-gray-600 mb-6">Ultimo aggiornamento: 17 Gennaio 2026</p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Cosa sono i Cookie</h2>
              <p className="text-gray-700">
                I cookie sono piccoli file di testo che vengono memorizzati sul tuo dispositivo quando visiti un sito web. 
                Permettono al sito di riconoscere il tuo dispositivo e memorizzare alcune informazioni sulle tue preferenze o azioni passate.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Tipologie di Cookie Utilizzati</h2>
              
              <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">Cookie Tecnici (Necessari)</h3>
              <p className="text-gray-700 mb-4">
                Questi cookie sono essenziali per il corretto funzionamento del sito e non possono essere disabilitati. 
                Non raccolgono informazioni personali identificabili.
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Session Cookie:</strong> Mantengono la tua sessione attiva durante la navigazione</li>
                <li><strong>Preferenze Lingua:</strong> Memorizzano la lingua scelta</li>
                <li><strong>Cookie di Sicurezza:</strong> Prevengono attacchi informatici</li>
              </ul>

              <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">Cookie Analitici (Opzionali)</h3>
              <p className="text-gray-700 mb-4">
                Ci aiutano a capire come i visitatori utilizzano il sito, permettendoci di migliorare l'esperienza utente.
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Google Analytics:</strong> Raccoglie statistiche anonime sulla navigazione</li>
                <li><strong>Durata:</strong> Fino a 2 anni</li>
                <li><strong>Finalità:</strong> Analisi del traffico e comportamento degli utenti</li>
              </ul>

              <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">Cookie di Terze Parti</h3>
              <p className="text-gray-700 mb-4">
                Alcuni servizi integrati nel sito utilizzano cookie di terze parti:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Google Maps:</strong> Per visualizzare mappe interattive</li>
                <li><strong>YouTube/Vimeo:</strong> Per incorporare video (se presenti)</li>
                <li><strong>Social Media:</strong> Per i pulsanti di condivisione social</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Gestione dei Cookie</h2>
              <p className="text-gray-700 mb-4">
                Puoi gestire le tue preferenze sui cookie in qualsiasi momento:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Banner Cookie:</strong> Alla prima visita, puoi accettare o rifiutare i cookie opzionali</li>
                <li><strong>Impostazioni Browser:</strong> Puoi bloccare o eliminare i cookie dalle impostazioni del tuo browser</li>
                <li><strong>Opt-out Analitics:</strong> Puoi disattivare Google Analytics tramite <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700">questo strumento</a></li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Come Bloccare i Cookie</h2>
              <p className="text-gray-700 mb-4">
                Puoi bloccare i cookie modificando le impostazioni del tuo browser:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Chrome:</strong> Impostazioni > Privacy e sicurezza > Cookie e altri dati dei siti</li>
                <li><strong>Firefox:</strong> Opzioni > Privacy e sicurezza > Cookie e dati dei siti web</li>
                <li><strong>Safari:</strong> Preferenze > Privacy > Gestisci dati dei siti web</li>
                <li><strong>Edge:</strong> Impostazioni > Cookie e autorizzazioni sito</li>
              </ul>
              <p className="text-gray-700 mt-4">
                <strong>Nota:</strong> Bloccando tutti i cookie, alcune funzionalità del sito potrebbero non funzionare correttamente.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Durata dei Cookie</h2>
              <p className="text-gray-700">
                I cookie possono essere:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-2">
                <li><strong>Session Cookie:</strong> Eliminati alla chiusura del browser</li>
                <li><strong>Persistent Cookie:</strong> Rimangono sul dispositivo per un periodo determinato (fino a 2 anni)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Aggiornamenti</h2>
              <p className="text-gray-700">
                Questa Cookie Policy può essere aggiornata periodicamente. Ti invitiamo a consultarla regolarmente per essere sempre informato.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Contatti</h2>
              <p className="text-gray-700">
                Per domande sui cookie, contattaci:<br />
                Email: <a href="mailto:info@offroaditalia.com" className="text-blue-600 hover:text-blue-700">info@offroaditalia.com</a><br />
                WhatsApp: <a href="https://wa.me/393793793030" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700">+39 379 379 3030</a>
              </p>
            </section>
          </div>

          <div className="mt-8 pt-8 border-t">
            <Link to="/" className="text-blue-600 hover:text-blue-700 font-semibold">
              ← Torna alla Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;